// @flow

import React from "react";
import { addModifierTo } from "ui-kit/utils/component";
import { Link } from "react-router-dom";
import cx from "classnames";
import type { Node } from "react";
import "./Button.scss";

type Props = {
  children: Node,
  className?: string,
  disabled?: boolean,
  type?: string,

  primary?: boolean,
  secondary?: boolean,
  cancel?: boolean,
  popup?: boolean,
  round?: boolean,
  primarySquare?: primarySquare,
  whiteSquare?: whiteSquare,

  large?: boolean,
  medium?: boolean,
  small?: boolean
};

const modifyButton = addModifierTo("Button");
export const buttonClasses = (props) => {
  const {
    className,
    success,
    primary,
    secondary,
    cancel,
    round,
    popup,
    large,
    medium,
    small
  } = props;

  return cx("Button", {
    [modifyButton("primary")]:       primary,
    [modifyButton("secondary")]:     secondary,
    [modifyButton("cancel")]:       cancel,
    [modifyButton("popup")]:       popup,
    [modifyButton("success")]:       success,
    [modifyButton("round")]:       round

  }, {
    [modifyButton("large")]:  large,
    [modifyButton("medium")]: medium || !(large || small),
    [modifyButton("small")]:  small
  }, className);
};


const Button = (props: Props) => {
  const {
    children,
    type,
    className,
    success,
    primary,
    secondary,
    cancel,
    round,
    popup,
    large,
    medium,
    small,
    ...rest
  } = props;

  // Take "to" from props for passing it with "rest"
  const Tag = props.to ? Link : "button";
  const classes = buttonClasses(props);
  return (
    <Tag
      className={classes}
      type={type || "button"}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export default Button;



// WEBPACK FOOTER //
// ./src/ui-kit/components/button/Button.js